import type { RouteObject } from "react-router-dom";
import { AttendancePage } from "./AttendancePage";

export const routes: RouteObject[] = [{ path: "attendance", element: <AttendancePage /> }];
